import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import globalRelay from '../globalRelay';
import * as jobCostActions from '../jobCostActions';import jobCostFactory from '../models/jobCostModel';
import { Spinner } from './sharedComponents';

export default class JobCostImportWorkAreas extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(this.props);

		this.cancel = this.cancel.bind(this);
		this.selectBaseTemplate = this.selectBaseTemplate.bind(this);
		this.save = this.save.bind(this);
		this.onCheckboxChange = this.onCheckboxChange.bind(this);
	}

	getStateFromProps (props) {
		const { contractorTemplates } = props;
		const state = _.assign({
			contractorTemplates: _.sortBy(contractorTemplates, ['name']),
			selectedTemplate: undefined,
			workAreaKeysToClone: []
		}, this.state);

		this.setWorkAreasToClone(state);

		return state;
	}

	updateState (updater) {
		this.setState(previousState => {
			const nextState = _.assign({}, previousState);
			updater(nextState);
			return nextState;
		});
	}

	selectBaseTemplate (e) {
		const targetKey = e.target.value;

		this.updateState(nextState => {
			nextState.selectedTemplate = _.find(nextState.contractorTemplates, { key: targetKey });
			this.setWorkAreasToClone(nextState);
		});
	}

	setWorkAreasToClone (state) {
		if (state.selectedTemplate) {
			state.workAreaKeysToClone = _.map(state.selectedTemplate.workAreas, workArea => workArea.key);
		}
		else {
			state.workAreaKeysToClone = [];
		}
	}

	cloneWorkArea (template, target, workAreaKey) {
		const workArea = template.workAreas[workAreaKey];
		const lineItems = _.filter(template.lineItems, { workAreaKey: workAreaKey });
		const settings = _.filter(template.settings, { workAreaKey: workAreaKey });
		const specifications = _.filter(template.specifications, { workAreaKey: workAreaKey });
		const clonedWorkArea = workArea.clone();
		const clonedWorkAreaKey = clonedWorkArea.key;

		target.workAreas.add(target.createWorkArea(clonedWorkArea.toDocument()));

		_.forEach(lineItems, item=> {
			const clone = item.clone();
			clone.workAreaKey = clonedWorkAreaKey;

			// Trigger updates that could impact cost/pricing based on values external to the job cost
			// Order matters here
			globalRelay.triggerJobCostLineUpdate(clone, 'productName', target);
			globalRelay.triggerJobCostLineUpdate(clone, 'glassTypeKey', target);
			globalRelay.triggerJobCostLineUpdate(clone, 'doorSizeKey', target);

			target.lineItems.add(clone);
		});

		_.forEach(settings, item=> {
			const clone = item.clone();
			clone.workAreaKey = clonedWorkAreaKey;
			target.settings.add(clone);
		});

		_.forEach(specifications, item=> {
			const clone = item.clone();
			clone.workAreaKey = clonedWorkAreaKey;
			target.specifications.add(clone);
		});
	}

	cancel () {
		this.props.close();
	}

	save () {
		const { selectedTemplate, workAreaKeysToClone } = this.state;
		const { targetJobCost, close } = this.props;
		const saveModalKey = 'jobcost-import-work-areas-spinner';

		if (!this.canAttemptSave()) {
			return;
		}

		const diffBase = jobCostFactory(targetJobCost.toDocument());

		_.forEach(workAreaKeysToClone, key => {
			this.cloneWorkArea(selectedTemplate, targetJobCost, key);
		});

		const patch = targetJobCost.getPatch(diffBase);

		actions.pushModal({ key: saveModalKey, component: (<Spinner />) });
		jobCostActions.saveJobCost({ jobCost: targetJobCost.toDocument(), patch: patch })
			.finally(() => {
				actions.deleteModal({ key: saveModalKey });
				close();
			});
	}

	onCheckboxChange (e) {
		const isChecked = e.target.checked;
		const key = e.target.value;

		this.updateState(nextState => {
			if (!isChecked) {
				nextState.workAreaKeysToClone.splice(nextState.workAreaKeysToClone.indexOf(key), 1);
			}
			else {
				nextState.workAreaKeysToClone.push(key);
			}
		});
	}

	canAttemptSave () {
		const { workAreaKeysToClone } = this.state;

		return workAreaKeysToClone.length;
	}

	render () {
		const { contractorTemplates, selectedTemplate, workAreaKeysToClone } = this.state;
		const templateOptions = contractorTemplates.map(jobCost => (<option key={jobCost.key} value={jobCost.key}>{jobCost.name}</option>));
		const workAreas:JSX.Element[] = [];

		templateOptions.unshift(<option key="empty" value="">Select a Template</option>);
		if (selectedTemplate) {
			_.forEach(selectedTemplate.workAreas, workarea =>{
				workAreas.push(<label key={workarea.key}><input type="checkbox" checked={(workAreaKeysToClone.indexOf(workarea.key) !== -1)} value={workarea.key} onChange={this.onCheckboxChange}/>{ workarea.name }</label>);
			});
		}

		return (
			<div className="window">
				<header>
					<button className="cancel" onClick={this.cancel} ><span>Cancel</span> </button>
					<span>Import from Builder Model</span>
					<button className={ this.canAttemptSave() ? 'action save' : 'disabled action save'} onClick={this.save} ><span>OK</span></button>
				</header>
				<div className="views">
					<div className="content in scrollable">
						<section>
							<div className="inner">
								<table className="centered" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<td />
											<td><strong>Select a Builder Model</strong></td>
											<td>
												<select onChange={ this.selectBaseTemplate }>
													{templateOptions}
												</select>
											</td>
											<td />
										</tr>
										<tr>
											<td />
											<td className={ workAreas.length === 0 ? 'disabled' : ''}><strong>Included Model Work Areas</strong></td>
											<td className={ workAreas.length === 0 ? 'disabled' : ''}>
												{ workAreas.length ? workAreas : <label>No Work Areas Available</label> }
											</td>
											<td />
										</tr>
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
			</div>
		);
	}
}